import { IParkingAvailability } from '../domain/models/IParkingAvailability';
import ParkingCard from './ParkingCard';
import { InfoCardWrapper } from '../../security/ui/CheckpointsList';
import { findParkingPoiPosition } from '../domain/utils/findParkingPoiPosition';
import { useApi } from '../../../data/hooks/useApi';
import { PARKING_AVAILABILITY_RATES_API } from '../domain/api';
import { AirportCodes } from '../../../types/airports';
import { IParkingRateResponse } from '../domain/models/IParkingRateResponse';
import { IParkingLocationEntry } from '../../../contentful/types/IParkingLocationEntry';
import { applyContentfulOverrides } from '../domain/utils/applyContentfulOverrides';

interface IParkingListProps {
	parkingOptions?: IParkingAvailability[];
	airportCode?: AirportCodes;
	contentfulParkingLocations?: IParkingLocationEntry[];
}

export default function ParkingList({
	parkingOptions,
	airportCode,
	contentfulParkingLocations,
}: IParkingListProps) {
	const { data, loading, error } = useApi<IParkingRateResponse>().useGetApi({
		url: `${PARKING_AVAILABILITY_RATES_API}/${airportCode}`,
	});

	const displayedParkings =
		parkingOptions &&
		applyContentfulOverrides(parkingOptions, contentfulParkingLocations);

	return (
		<InfoCardWrapper>
			{displayedParkings?.map(({ parking, override }) => {
				const position =
					contentfulParkingLocations &&
					findParkingPoiPosition(contentfulParkingLocations, parking.id);

				const price = data?.data.rates.find((r) => r.id === parking.id)?.rate;

				return (
					<ParkingCard
						key={parking.id}
						parking={parking}
						override={override}
						position={position}
						price={price}
						priceLoading={loading}
						priceError={!!error}
					/>
				);
			})}
		</InfoCardWrapper>
	);
}
